<template>
  <div class="homeworkDetail">
    <Navbar title="作业详情" :backNative="isApp" :leftArrow="!isShare" />

    <van-pull-refresh
      v-model="refreshing"
      style="min-height: 100vh"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="userInfo">
          <div class="userAvatar">
            <img
            @click="toUser(detail.memberId)"
              :src="
                detail.avatar
                  ? detail.avatar
                  : require('../assets/images/default.png')
              "
              alt=""
            />
          </div>

          <div class="info_right">
            <div class="userName">
              <div>{{ detail.name }}</div>
              <div>{{ detail.releaseTime }}</div>
            </div>

            <div class="learned">
              已学习 <span>{{ detail.studyTime }}</span> 天
            </div>
          </div>
        </div>
        <div class="userWord">
          {{ detail.title }}
        </div>
        <!-- 视频部分 -->
        <div class="videoInfo">
          <video :src="detail.video" :poster="detail.image" controls></video>
        </div>

        <div class="analyse" v-if="detail.classesTypeId === 0">
          <div class="analyse_title">完整分析</div>

          <div class="analyse_list">
            <div class="analyse_card">
              <div>完整度</div>
              <div v-if="detail.integrity == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.integrity == 1
                    ? require('../assets/images/pass.png')
                    : detail.integrity == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>

            <div class="analyse_card">
              <div>和弦</div>
              <div v-if="detail.chord == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.chord == 1
                    ? require('../assets/images/pass.png')
                    : detail.chord == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>

            <div class="analyse_card">
              <div>熟练度</div>
              <div v-if="detail.skilled == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.skilled == 1
                    ? require('../assets/images/pass.png')
                    : detail.skilled == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>

            <div class="analyse_card">
              <div>指法</div>
              <div v-if="detail.fingering == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.fingering == 1
                    ? require('../assets/images/pass.png')
                    : detail.fingering == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>

            <div class="analyse_card">
              <div>节奏</div>
              <div v-if="detail.rhythm == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.rhythm == 1
                    ? require('../assets/images/pass.png')
                    : detail.rhythm == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>

            <div class="analyse_card">
              <div>手型</div>
              <div v-if="detail.handshape == 0 || isPass == 0">-</div>
              <img
                v-else
                :src="
                  detail.handshape == 1
                    ? require('../assets/images/pass.png')
                    : detail.handshape == 2
                    ? require('../assets/images/tips_yellow.png')
                    : require('../assets/images/nopass.png')
                "
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 教师点评 -->
        <div class="teacherComment" v-if="isPass != 0">
          <img
            class="commentIcon"
            src="../assets/images/commentIcon.png"
            alt=""
          />
          <div class="comment_word">{{ detail.teacherReview }}</div>

          <div class="picsList" v-if="detail.teacherPicture.length > 0">
            <div
              class="picItem"
              v-for="(items, index) in detail.teacherPicture"
              @click="watchPic(index)"
              :key="index"
              :style="{
                background:
                  'url(' +
                  detail.teacherPicture[index] +
                  ') no-repeat center center',
                backgroundSize: '100% auto',
              }"
            ></div>
          </div>

          <div class="line"></div>

          <div class="teacherAvatar">
            <img
              :src="
                detail.teacherAvatar
                  ? detail.teacherAvatar
                  : require('../assets/images/default.png')
              "
              alt=""
            />
            <div>{{ detail.teacherName }}</div>
          </div>
        </div>

        <div class="line"></div>

        <div class="comments" v-if="isPass == 1">
          <div class="comment_title">
            评论<span>{{ detail.workCommentCount }}</span>
          </div>

          <div class="commentBox">
            <div class="items" v-for="(item, index) in list" :key="index">
              <div class="avater">
                <img
                @click="toUser(item)"
                  :src="
                    item.avatar != null && item.avatar != ''
                      ? item.avatar
                      : require('../assets/images/default.png')
                  "
                  alt=""
                />
              </div>
              <div class="content">
                <div class="topBox">
                  <div class="name">{{ item.name }}</div>
                  <div class="options">
                    <img src="../assets/images/options.png" alt="" />
                  </div>
                </div>
                <div class="text" @click="replyOtherUser(item.workId, item.memberId)">{{ item.content }}</div>
                <!-- <div class="text">
                  {{ item.content }}
                </div> -->
                <div class="time">{{ item.releaseTime }}</div>

                <div class="childReply">
                  <div
                    class="childItems"
                    v-for="(childItem, childIndex) in item.workCommentList"
                    :key="childIndex"
                  >
                    <div class="topBox">
                      <div class="topLeft">
                        <div class="childAvater">
                          <img
                          @click="toUser(item.workCommentList[0])"
                            :src="
                              childItem.avatar != null && childItem.avatar != ''
                                ? childItem.avatar
                                : require('../assets/images/default.png')
                            "
                            alt=""
                          />
                        </div>

                        <div class="replyUsers">
                          <div class="beforeUser">
                            {{ childItem.memberName }}
                          </div>
                          <span>回复</span>
                          <div class="afterUser">
                            {{ childItem.replyCName }}
                          </div>
                        </div>
                      </div>
                      <div class="topRight">
                        <img src="../assets/images/options.png" alt="" />
                      </div>
                    </div>
                    <div
                      class="childText"
                      @click="replyOtherUser(item.workId, childItem.memberId)"
                    >
                      {{ childItem.content }}
                    </div>
                    <div class="childTime">{{ childItem.releaseTime }}</div>
                  </div>
                  <div class="more" v-if="item.workCommentSize != 0 && !item.hideMore">
                    <span @click="getMore(item.workId)">更多{{item.workCommentSize}}条回复</span>
                    <div class="moreIcon">
                      <img src="../assets/images/row_down.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="comment_list">
            <div
              class="comment_card"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="comment_avatar">
                <img
                  :src="
                    item.avatar != null && item.avatar != ''
                      ? item.avatar
                      : require('../assets/images/default.png')
                  "
                  alt=""
                />
              </div>
              <div class="comment_right">
                <div class="comment_user">
                  <div class="comment_name">{{ item.name }}</div>
                  <div class="sendtime">{{ item.releaseTime }}</div>
                </div>

                <div class="comment_word comment1">{{ item.content }}</div>
              </div>
            </div>
          </div> -->
        </div>
      </van-list>
    </van-pull-refresh>

    <div
      class="reSubmit"
      v-if="isPass != 0 && isSelf && detail.score != 3"
      @click="toSubmit"
    >
      <span>重新提交</span>
    </div>

    <div class="reSubmit" v-if="isPass == 0">
      <span class="reSubmit2">作业审核中</span>
    </div>

    <div class="comment_input" v-if="isPass == 1 && !isShare && !isSelf">
      <van-field
        class=""
        ref="commentInput"
        @focus="inputFocus"
        @blur="inputBlur"
        v-model="commentWord"
        placeholder="说说你的看法"
      />

      <div class="share" @click="toShare" v-if="!inputFoucus">
        <img src="../assets/images/share.png" alt="" />
        <span>分享 </span>
      </div>

      <div class="parise" @click="toPraise" v-if="!inputFoucus">
        <img
          :src="
            detail.memberGiveALike
              ? require('../assets/images/parise_act.png')
              : require('../assets/images/parise.png')
          "
          alt=""
        />
        <span :class="detail.memberGiveALike ? 'act' : ''">{{
          detail.thumbCount
        }}</span>
      </div>

      <div class="sendBt" @click="toSend" v-if="inputFoucus">发送</div>
    </div>

    <div class="downloadApp" v-if="isShare">
      <img src="../assets/images/appIcon.png" alt="" />
      <div class="infoWord">
        <div>吉他自学</div>
        <div>离梦想更进一步</div>
      </div>

      <a
        class="downloadBt"
        href="https://sj.qq.com/myapp/detail.htm?apkName=com.hoge.app6857ug38pd"
      >
        <div>下载</div>
      </a>
    </div>

    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '158px' }"
    >
      <div class="pop_title">分享到</div>
      <div class="icons">
        <div class="icon_item" @click="toWechat">
          <img src="../assets/images/wechat.png" alt="" />
          <span>微信</span>
        </div>

        <div class="icon_item" @click="toFriendCircle">
          <img src="../assets/images/friendCircle.png" alt="" />
          <span>朋友圈</span>
        </div>

        <div class="icon_item" @click="toQQ">
          <img src="../assets/images/qq.png" alt="" />
          <span>QQ</span>
        </div>
      </div>
    </van-popup>

    <LikeModal
      v-if="likeModalFlag"
      @closeModal="setLikeModal(false)"
      @giveLikeCallBack="successGiveLike"
    ></LikeModal>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";
import http from "../utils/http";
import { Toast, ImagePreview } from "vant";
import LikeModal from "./notesDetail/LikeModal.vue";
export default {
  data() {
    return {
      commentWord: "",
      show: false,
      ispraise: false,
      inputFoucus: false, //文本框聚焦
      size: 20,
      current: 1,
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      showTips: false, //展示弹框
      detail: {},
      list: [], //评论列表
      isPass: '', // 作业状态: 0待审核 1通过 2未通过 3不参与评分
      isShare: false,
      isApp: false, //是否原生进入
      isSelf: false, //是否是本人
      commentType: 0, // 判断是回复用户还是回复文章
      replyMemberId: "", // 被回复人的id
      parentId: "", // 回复别人的评论时，一级评论的id
      likeModalFlag: false, //点赞框
      userId:'',
      userName:''
    };
  },
  computed: {
    isFullScreen() {
      return (
        window &&
        testUA("iPhone") &&
        window.screen.height >= 812 &&
        window.devicePixelRatio >= 2
      );
    },
  },
  mounted() {
    this.getDetail();
    if (this.$route.query.isShare) {
      this.isShare = this.$route.query.isShare;
    }
    if (this.$route.query.isApp) {
      this.isApp = true;
    }
    if (this.$route.query.isSelf) {
      this.isSelf = true;
    }
  },
  activated() {
    this.getDetail();
  },
  methods: {
    //跳转用户信息
    toUser(params) {
      if (params.memberId) {
        http.guitarAppListener("toUser", {
          memberId: params.memberId,
        });
      } else {
        http.guitarAppListener("toUser", {
          memberId: params,
        });
      }
    },
    getMore(id) {
      // 获取更多的评论
      let params = {};
      params.commentId = id;
      http.getMoreComment(params).then((res) => {
        if (res) {
          this.list.map((item, index) => {
            if (item.workId == id) {
              item.workCommentList.push(...res);
              item.hideMore = true;
            }
          });
        }
      });
    },
    //关闭或者开启点赞模态框
    setLikeModal(flag) {
      // console.log(likeModalFlag);
      this.likeModalFlag = flag;
    },

    testUA(str) {
      return navigator.userAgent.indexOf(str) > -1;
    },
    // 判断是iphoneX及以后的iphone手机（即iphone带全面屏的手机）

    toWechat() {
      let query = this.$route.query;
      http.guitarAppListener("toWechat", {
        path: `/workDetail?id=${query.id}&type=${query.type}&isShare=true`,
        img: this.detail.image,
        title: this.detail.homeworkCopy,
        content: this.detail.teacherReview,
      });
    },
    toFriendCircle() {
      let query = this.$route.query;
      http.guitarAppListener("toFriendCircle", {
        path: `/workDetail?id=${query.id}&type=${query.type}&isShare=true`,
        img: this.detail.image,
        title: this.detail.homeworkCopy,
        content: this.detail.teacherReview,
      });
    },
    toQQ() {
      let query = this.$route.query;
      http.guitarAppListener("toQQ", {
        path: `/workDetail?id=${query.id}&type=${query.type}&isShare=true`,
        img: this.detail.image,
        title: this.detail.homeworkCopy,
        content: this.detail.teacherReview,
      });
    },
    toSubmit() {
      //  http.guitarAppListener('backToNative',{})
      let query = this.$route.query;
      http.guitarAppListener("toSubmit", {
        courseDetailId: this.detail.courseDetailId,
        type: query.type,
      });
    },
    toPraise() {
      let flag = localStorage.getItem("likeTips");

      if (this.like === 1) {
        return;
      }
      if (flag) {
        http
          .giveALike({ dataId: this.$route.query.id, type: 2 })
          .then((res) => {
            
          });
        return;
      }
      this.setLikeModal(true);
    },
    successGiveLike(flag) {
      //点赞
      let query = this.$route.query;
      if (this.detail.memberGiveALike) {
        return false;
      }

      // this.ispraise = !this.ispraise;
      http.giveALike({ dataId: query.id, type: 2 }).then((res) => {
        //type:2作业点赞 1课节点赞
        http
          .getMemberWorkVO({
            classType: query.type,
            MemberWorkId: query.id,
            size: this.size,
            current: this.current,
          })
          .then((res) => {
            if (flag) {
              localStorage.setItem("likeTips", "1");
            }
            let obj = res;
            if (obj.teacherPicture) {
              obj.teacherPicture = obj.teacherPicture.split(",");
            } else {
              obj.teacherPicture = [];
            }
            this.detail = obj;
          });
      });
    },

    // 预览图片
    watchPic(index) {
      ImagePreview({
        images: this.detail.teacherPicture,
        startPosition: index,
        loop: false,
      });
    },
    toShare() {
      this.show = true;
    },
    //聚焦
    inputFocus() {
      if (this.replyMemberId && this.parentId) {
        this.commentType = 1;
      }
      this.inputFoucus = true;
    },
    inputBlur() {
      setTimeout(() => {
        this.parentId = "";
        this.replyMemberId = "";
        this.inputFoucus = false;
        this.commentType = 0;
      }, 200);
    },
    replyOtherUser(parentId, id) {
      //回复别人
      this.commentType = 1;
      this.replyMemberId = id;
      this.parentId = parentId;
      this.$refs.commentInput.focus();
    },
    toSend() {
      //发送评论
      if (this.commentWord.trim() == "") {
        Toast("评论内容不能为空");
        return false;
      }
      Toast.loading();
      let params = {};
      params = {
        content: this.commentWord,
        memberWorkId: this.detail.id,
        authorId: this.detail.memberId,
        workType: 0,
        commentType: this.commentType,
      };
      if (this.commentType == 1) {
        // 如果是回复别人的评论，加上两个参数
        params.replyMemberId = this.replyMemberId;
        params.parentId = this.parentId;
      }
      http.sendComment(params).then((res) => {
        this.commentWord = "";
        Toast("评论成功");
        this.current = 1;

        this.getDetail();
        this.inputFoucus = false;
        this.$refs.commentInput.blur();
      });
    },
    getuserName() {
      http.getUserInfo().then((res) => {
        this.userId = res.id;
        this.userName = res.name;
      });
    },
    getDetail() {
      let query = this.$route.query;
      http
        .getMemberWorkVO({
          size: this.size,
          current: this.current,
          classType: query.type,
          MemberWorkId: query.id,
        })
        .then((res) => {
          this.isPass = res.status;
          setTimeout(() => {
            if (res.workCommentList.length > 0) {
              if (this.refreshing || this.current == 1) {
                this.list = [...res.workCommentList];
                this.refreshing = false;
              } else {
                this.list = [...this.list, ...res.workCommentList];
              }

              this.loading = false;
            } else {
              this.finished = true;
              this.refreshing = false;
              this.current--;
            }
          }, 500);

          let obj = res;
          if (obj.teacherPicture) {
            obj.teacherPicture = obj.teacherPicture.split(",");
          } else {
            obj.teacherPicture = [];
          }
          this.detail = obj;

          //       if(localStorage.getItem('userInfo')){
          //     let data=JSON.parse(localStorage.getItem('userInfo'))

          //    if(data.id==res.memberId){
          //      this.isSelf=true
          //    }
          // }
        });
    },
    onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }
      this.getDetail();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current = 1;
      this.onLoad();
    },
  },
  components: {
    Navbar,
    LikeModal,
  },
};
</script>
<style lang="less" scoped>
.homeworkDetail {
  position: relative;
  padding-bottom: 66px;
  min-height: 100vh;
  .userInfo {
    display: flex;
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 12px;
    .userAvatar img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
    }

    .info_right {
      margin-left: 12px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .userName {
        div:nth-child(1) {
          font-size: 15px;
          font-weight: bold;
        }
        div:nth-child(2) {
          margin-top: 2px;
          font-size: 11px;
          color: #9b9aa2;
        }
      }

      .learned {
        color: #9b9aa2;
        font-size: 11px;
        span {
          font-size: 20px;
          color: #fc541e;
          font-weight: bold;
        }
      }
    }
  }
  .userWord {
    width: calc(100% - 32px);
    font-size: 15px;
    color: #222030;
    margin: 0 auto;
    margin-top: 5px;
  }
  .videoInfo {
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 12px;
    video {
      width: 100%;
      height: 194px;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  .analyse {
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 22px;
    .analyse_list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 12px;
      .analyse_card {
        width: 167px;
        height: 40px;
        padding: 0 16px;
        box-sizing: border-box;
        background: #f6f6f6;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        div {
          font-size: 15px;
          color: #222030;
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
      .analyse_card:nth-child(odd) {
        border-radius: 6px 0px 0px 0px;
      }
      .analyse_card:nth-child(even) {
        border-radius: 0px 6px 0px 0px;
      }
    }
  }

  .analyse_title {
    font-size: 20px;
    font-weight: 600;
  }
  .teacherComment {
    width: calc(100% - 32px);
    margin: 0 auto;
    padding: 16px;
    box-sizing: border-box;
    background: #f6f6f6;
    border-radius: 6px;
    margin-bottom: 24px;
    .commentIcon {
      width: 60px;
      height: 15px;
    }
    .comment_word {
      font-size: 15px;
      color: #222030;
      margin-top: 18px;
    }

    .teacherAvatar {
      display: flex;
      align-items: center;
      margin-top: 8px;
      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      div {
        font-size: 12px;
        margin-left: 8px;
        color: #6c6b75;
      }
    }
  }
  .picsList {
    display: flex;
    margin-top: 12px;
    .picItem {
      width: 42px;
      margin-left: 3px;
      height: 42px;
      &:nth-of-type(1) {
        margin: 0;
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #e1e1e3;
    margin-top: 12px;
  }

  .commentBox {
    .items {
    margin-top: 12px;
    display: flex;
    margin-bottom: 20px;
    .avater {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
      .content {
        flex: 1;
        margin-left: 8px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f4f4f5;
        overflow: hidden;
        .topBox {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .name {
            font-size: 13px;
            color: #6f6e78;
          }
          .options {
            width: 14px;
            img {
              width: 100%;
            }
          }
        }
        .text {
          font-size: 14px;
          color: #222030;
          // max-width: 90%;
          word-wrap: break-word;
          margin-bottom: 8px;
        }
        .time {
          color: #9b9aa2;
          font-size: 11px;
        }

        .childReply {
          margin: 16px 0;
          width: 100%;
          .childItems {
            margin-bottom: 8px;
            width: 100%;
            &:nth-last-child(1) {
              margin: 0;
            }
            .topBox {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .topLeft {
                display: flex;
                align-items: center;
                .childAvater {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                object-fit: cover;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  object-fit: cover;
                }
                }
                .replyUsers {
                  margin-left: 4px;
                  flex: 1;
                  display: flex;
                  font-size: 13px;
                  color: #6f6e78;
                  font-weight: 400;
                  span {
                    color: #222030;
                    margin: 0px 4px;
                  }
                }
              }
              .topRight {
                width: 14px;
                img {
                  width: 100%;
                }
              }
            }
            .childText {
              font-size: 14px;
              color: #222030;
              font-weight: 400;
              margin: 8px 0;
            }
            .childTime {
              color: #9b9aa2;
              font-size: 11px;
            }
          }
          .more {
            display: flex;
            align-items: center;
            margin-top: 16px;
            span {
              font-size: 13px;
              color: #9b9aa2;
            }
            .moreIcon {
              margin-left: 4px;
              width: 10px;
              img {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .comments {
    width: calc(100% - 32px);
    margin: 0 auto;
    margin-top: 24px;
    .comment_title {
      font-size: 20px;
      color: #222030;
      font-weight: 600;
      span {
        font-size: 18px;
        color: #9b9aa2;
      }
    }
  }

  .comment_card {
    width: 100%;
    display: flex;
    margin-top: 12px;
    .comment_avatar img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      object-fit: cover;
    }
    .comment_right {
      flex: 1;
      margin-left: 8px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f4f4f5;
    }
    .comment_user {
      .comment_name {
        font-size: 13px;
        color: #222030;
      }
      .sendtime {
        color: #a1a0a8;
        font-size: 8px;
        margin-top: 3px;
      }
    }
    .comment_word {
      font-size: 14px;
      color: #222030;
      word-break: break-all;
      margin-top: 13px;
    }
    // justify-content: space-between;
  }
  .downloadApp {
    padding-right: 16px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 49px;
    border-top: 1px solid #e9e9eb;
    background: #fff;
    display: flex;
    padding: 0 20px;
    align-items: center;
    // justify-content: space-around;
    box-sizing: border-box;
    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
    }
    .infoWord {
      margin-left: 20px;
      div:nth-child(1) {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .downloadBt {
      flex: 1;
      display: flex;
      flex-direction: row-reverse;
      div {
        width: 70px;
        height: 30px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 31px;
        background: linear-gradient(135deg, #ff7337 0%, #fc541e);
        border-radius: 6px;
      }
    }
  }
  .comment_input {
    padding-right: 16px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 49px;
    border-top: 1px solid #e9e9eb;
    background: #fff;
    display: flex;
    // padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .van-field {
      width: 263px;
      border: none !important;
      // /deep/ input{
      //   border:none !important;
      //    height: 21px !important;
      // }
      // height: 21px;
    }

    .share,
    .parise {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 22px;
        height: 22px;
      }
      span {
        font-size: 8px;
        display: inline-block;
        margin-top: 2px;
        color: #222030;
      }
      .act {
        font-size: 10px;
        color: #fc541e;
      }
    }
  }
}
.reSubmit {
  height: 70px;
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    display: inline-block;
    width: calc(100% - 32px);
    text-align: center;
    line-height: 46px;
    font-size: 15px;
    color: #fff;
    height: 46px;
    background: linear-gradient(135deg, #ff7337 0%, #fc531d);
    border-radius: 6px;
  }
  .reSubmit2 {
    background: #c7c7cb;
  }
}

.pop_title {
  text-align: center;
  font-size: 15px;
  color: #222030;
  margin-top: 16px;
}
.icons {
  width: calc(100% - 124px);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.icon_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 52px;
    height: 52px;
  }
  span {
    display: inline-block;
    margin-top: 8px;
    font-size: 15px;
    color: #222030;
  }
}

.sendBt {
  width: 60px;
  height: 32px;
  background: linear-gradient(135deg, #ff7337 0%, #fc531d);
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 6px;
  position: relative;
  z-index: 9999999;
}
</style>


